import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const resp = await fetch(`${API}/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "X-Session-ID": sessionId },
        });
        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}));
          navigate("/admin/login", {
            replace: true,
            state: { error: err.detail || "Sign in failed" },
          });
          return;
        }
        const data = await resp.json();
        // Clear the fragment so it isn't left in the URL bar
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/admin/login", {
          replace: true,
          state: { error: "Network error during sign in" },
        });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--kw-cream)]">
      <div className="flex flex-col items-center gap-3 text-[color:var(--kw-charcoal-soft)]">
        <Loader2 className="animate-spin text-[color:var(--kw-red)]" size={28} />
        <div className="font-display font-bold tracking-widest uppercase text-sm">
          Signing you in…
        </div>
      </div>
    </div>
  );
}
